import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { createChatRoom } from "../firebase/firebase";
import styles from "./NewChatButton.module.css";

const NewChatButton: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [userId, setUserId] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleOpenModal = () => {
    setShowModal(true);
    setUserId("");
    setError("");
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleStartChat = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!userId.trim()) {
      setError("상대방 사용자 ID를 입력해주세요.");
      return;
    }

    if (!currentUser) {
      setError("로그인이 필요합니다.");
      return;
    }

    if (userId === currentUser.uid) {
      setError("자신과는 채팅할 수 없습니다.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // 채팅방 생성
      const chatRoomId = await createChatRoom(currentUser.uid, userId);

      // 채팅방으로 이동
      navigate(`/chat/${chatRoomId}`);
      setShowModal(false);
    } catch (error) {
      console.error("채팅방 생성 오류:", error);
      setError("채팅방을 생성하는데 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className={styles.newChatButton} onClick={handleOpenModal}>
        <span className={styles.newChatIcon}>+</span>
      </button>

      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.newChatModal}>
            <div className={styles.modalHeader}>
              <h3>새 채팅 시작하기</h3>
              <button className={styles.closeButton} onClick={handleCloseModal}>
                ×
              </button>
            </div>

            <form onSubmit={handleStartChat}>
              <div className={styles.modalContent}>
                <p className={styles.modalMessage}>
                  채팅할 상대방의 ID를 입력하세요
                </p>

                <div className={styles.inputWrapper}>
                  <input
                    type="text"
                    className={styles.userIdInput}
                    placeholder="상대방 ID"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    disabled={loading}
                  />
                </div>

                {error && <p className={styles.errorMessage}>{error}</p>}
              </div>

              <div className={styles.formActions}>
                <button
                  type="button"
                  className={styles.cancelButton}
                  onClick={handleCloseModal}
                  disabled={loading}
                >
                  취소
                </button>
                <button
                  type="submit"
                  className={styles.confirmButton}
                  disabled={loading || !userId.trim()}
                >
                  {loading ? "처리 중..." : "채팅 시작"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default NewChatButton;
